import React, { useCallback, useEffect, useState } from 'react';
import { Container } from './components/Container';
import { Button, ButtonModes } from './components/Button';

interface ResultItem {
  title: string,
  excerpt: string,
  image: string,
  date: string,
  url: string,
}

interface ResultsProps {
  results: ResultItem[],
  headline: string,
}

const SearchResults: React.FC<ResultsProps> = ({ results, headline }) => {
  if (results.length < 1) {
    return (
      <section>
        <p>Przykro nam, nie znaleziono nic dla podanej frazy.</p>
      </section>
    );
  }

  return (
    <>
      <h3 className="search__results__title">{headline}</h3>
      <section className="search__results">
        {results.map((item) => (
          <article
            key={item.url}
            className="search__results__item"
          >
            <div className="search__results__item__image">
              <a href={item.url}>
                {item.image ? (
                  <img src={item.image} alt="" />
                ) : null }
              </a>
            </div>
            <div className="search__results__item__body">
              <div className="search__results__item__body__text">
                <h2>
                  <a
                    href={item.url}
                  >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.title,
                    }}
                  />
                  </a>
                </h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.excerpt,
                  }}
                />
              </div>
              <div className="search__results__item__body__meta">
                <time>{item.date}</time>
                <a href={item.url}>Czytaj dalej</a>
              </div>
            </div>
          </article>
        ))}
      </section>
    </>
  );
};

const doSearch = async (query: string) => {
  try {
    const response = await fetch(`/api/search?q=${encodeURIComponent(query)}`);
    const apiResult = await response.json();

    return apiResult;
  } catch (error) {
    console.error('Search failedd', error);
    return [];
  }
};

export const SearchContent: React.FC<any> = (props) => {
  const [inputQuery, setInputQuery] = useState('');
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    const url = new URL(location.href);
    const queryFromUrl = url.searchParams?.get('q') || '';
    setInputQuery(queryFromUrl);
    setQuery(queryFromUrl);
  }, []);

  useEffect(() => {
    if (!query) {
      return;
    }
    doSearch(query)
      .then((res) => {
        setResults(res);
      });
  }, [query]);

  const handleSubmit = useCallback(async (e: SubmitEvent) => {
    e.preventDefault();
    const url = new URL(location.href);
    url.searchParams.set('q', inputQuery);
    history.pushState({}, '', url.toString());
    setQuery(inputQuery);
  }, [inputQuery]);

  return (
    <main className="search">
      <Container className="search__content">
        <div className="search__top">
          <h1>{props.title}</h1>
          <form
            /* @ts-ignore */
            onSubmit={handleSubmit}
            className="search__form"
            action="/szukaj"
          >
            <section>
              <label htmlFor="search">{props.explanation}</label>
              <input
                id="search"
                name="q"
                onChange={(e) => setInputQuery(e.target.value)}
                placeholder={props.placeholder}
                value={inputQuery}
              />
            </section>
            <Button
              mode={ButtonModes.primary}
              type="submit"
              isButton
            >
              {props.button}
            </Button>
          </form>
        </div>
        { query ? (
          <SearchResults results={results} headline={props.resultsHeadline} />
        ) : (
          <div className="search__empty">
            <p>Wpisz wyszukiwane słowo kluczowe w formularz powyżej i naciśnij enter lub przycisk szukaj</p>
          </div>
        ) }
      </Container>
    </main>
  );
};
